import { render, staticRenderFns } from "./AfterSalesServiceOrderEdit.vue?vue&type=template&id=c4ce770c&scoped=true&"
import script from "./AfterSalesServiceOrderEdit.vue?vue&type=script&lang=js&"
export * from "./AfterSalesServiceOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./AfterSalesServiceOrderEdit.vue?vue&type=style&index=0&id=c4ce770c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ce770c",
  null
  
)

export default component.exports